
import { Button, Col, DatePicker, Form, Input, Modal, Row, Select, Switch, Upload } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import Page from "../../../common/components/Page";
import CleanButton from "../../../common/components/CleanButton";
import useNewCivilCase from "./useNewCivilCase"
import moment from "moment";
import BannerCard from "../../../common/components/BannerCard";
import InputCurrency from "../../../common/components/InputCurrency";
import { useDispatch } from "react-redux";
import CivilEFilePayment from "./e-file-payment/civilEFilePayment";
import { defaultDateFormat } from "../../../common/constants/Helpers";
import { onFocus } from "@reduxjs/toolkit/dist/query/core/setupListeners";
import { NewCivilParty } from "../../../models/new-civil/new-civil-party";
import getConfigs from "../../../GetConfigs";



const NewCivilCase = () => {
  const { newCivilForm, submitNewCivilCase, caseTypesLoader, civilCaseTypes, handlePlaintiffBusiness, handleDefendantBusiness, plaintiffForm, defendantForm, isModalVisible, setIsModalVisible, handleActiveCaseType, activeCaseType, activePlaintiffIndex, plaintiffCount, goNextPlaintiff, goPrevPlaintiff, addPlaintiff, deletePlaintiff, activeDefendantIndex, defendantCount, goPrevDefendant, goNextDefendant, deleteDefendant, addDefendant, submitEFileLoader } = useNewCivilCase();
  const dispatch = useDispatch();
  const configurations = getConfigs([
    "cvAllowedDocumentExtensions"
  ]);
  return (
    <Page>
      <Page.Title icon="check" title="File New Civil Case" />
      <Page.Content>
        <Form form={newCivilForm} labelAlign="left" >
          <br />
          <Row gutter={16}>
            <Col xl={8} lg={8} md={8} sm={12} xs={12}>
              <Form.Item
                name="FilingDate"
                label="Filing Date"
              >
                <DatePicker format={defaultDateFormat} defaultValue={moment()} disabled />
              </Form.Item>
            </Col>
            <Col xl={8} lg={8} md={8} sm={12} xs={12}>

              <Form.Item
                name="CaseTypeId"
                label="Case Type"
                rules={[{ required: true }]}
              >
                <Select style={{ width: 120 }} loading={caseTypesLoader} onChange={handleActiveCaseType}>
                  {civilCaseTypes?.CaseTypes.map((caseType, index) =>
                    <Select.Option value={caseType.CaseTypePK} > {caseType?.Name}</Select.Option>)}
                </Select>
              </Form.Item>
            </Col>
            <Form.Item
              name="ClaimAmount"
              label="Claim Amount"
              rules={[{ required: true }]}
            >
              <InputCurrency min={1}></InputCurrency>
            </Form.Item>
          </Row>
          <Row gutter={16}>
            <Col xl={11} lg={11} md={11} sm={24} xs={24}>
              <Form form={plaintiffForm} name="plaintiffForm" onFinish={submitNewCivilCase} labelAlign="left"
                initialValues={{
                  Participants: [new NewCivilParty({ IsPlaintiff: true })]
                }}
              >
                <Form.List name="Participants">
                  {(fields, { add, remove }) => {
                    const total = fields.length;
                    const safeIndex = Math.min(activePlaintiffIndex, Math.max(0, total - 1));
                    const field = fields[safeIndex];
                    return (
                      <>
                        <div style={{ display: "none" }}>
                          {fields.map((f) => (
                            <React.Fragment key={`validation-${f.key}`}>
                              <Form.Item name={[f.name, "AddressLine1"]} rules={[{ required: activeCaseType?.IsEFileAddressRequiredPlaintiff == "Y" }]}>
                                <Input />
                              </Form.Item>
                              <Form.Item name={[f.name, "Zip"]} rules={[{ required: activeCaseType?.IsEFileAddressRequiredPlaintiff == "Y" }]}>
                                <Input />
                              </Form.Item>
                              <Form.Item name={[f.name, "City"]} rules={[{ required: activeCaseType?.IsEFileAddressRequiredPlaintiff == "Y" }]}>
                                <Input />
                              </Form.Item>
                              <Form.Item name={[f.name, "State"]} rules={[{ required: activeCaseType?.IsEFileAddressRequiredPlaintiff == "Y" }]}>
                                <Input />
                              </Form.Item>
                              <Form.Item name={[f.name, "Email"]} rules={[{ required: activeCaseType?.IsEmailRequiredRequiredPlaintiff == "Y" }]}>
                                <Input />
                              </Form.Item>
                              <Form.Item name={[f.name, "PhoneNumber"]} rules={[{ required: activeCaseType?.IsEFilePhoneRequiredPlaintiff == "Y" }]}>
                                <Input />
                              </Form.Item>
                            </React.Fragment>))}
                        </div>
                        <BannerCard title="Plaintiff Details">
                          <Row justify="space-between" align="middle" style={{ marginBottom: 12 }}>
                            <Col style={{ fontWeight: 600 }}>
                              Plaintiff {activePlaintiffIndex + 1} of {plaintiffCount}
                            </Col>
                          </Row>
                          <Form.Item name={[field.name, "IsPlaintiff"]} hidden />
                          <Row>
                            <Form.Item name={[field.name, "IsBusiness"]} label="Business Plaintiff" valuePropName="checked" initialValue={false}>
                              <Switch onChange={(checked) => handlePlaintiffBusiness(checked, field.name)} />
                            </Form.Item>
                          </Row>
                          <Form.Item noStyle shouldUpdate>
                            {() => {
                              const plaintiffBusiness = plaintiffForm.getFieldValue(["Participants", field.name, "IsBusiness"]);
                              return (
                                <>
                                  <Row gutter={16} hidden={plaintiffBusiness}>
                                    <Form.Item name={[field.name, "FirstName"]} label="First Name" style={{ width: '100%' }} rules={[{ required: !plaintiffBusiness }]}>
                                      <Input placeholder="Plaintiff First Name"
                                      />
                                    </Form.Item>
                                  </Row>
                                  <Row gutter={16}>
                                    <Form.Item name={[field.name, "LastName"]} label={plaintiffBusiness ? "Business Name" : "Last Name"} style={{ width: '100%' }} rules={[{ required: true }]}>
                                      <Input placeholder={plaintiffBusiness ? "Plaintiff's Business Name" : "Last Name"} />
                                    </Form.Item>
                                  </Row>
                                </>
                              );
                            }}
                          </Form.Item>
                          <Row gutter={16}>
                            <Form.Item name={[field.name, "AddressLine1"]} rules={[{ required: activeCaseType?.IsEFileAddressRequiredPlaintiff == "Y" }]} style={{ width: '100%' }} label="Address Line 1">
                              <Input />
                            </Form.Item>
                          </Row>
                          <Row gutter={16}>
                            <Form.Item name={[field.name, "AddressLine2"]} style={{ width: '100%' }} label="Address Line 2">
                              <Input />
                            </Form.Item>
                          </Row>
                          <Row gutter={16}>
                            <Col xl={11} lg={11} md={11} sm={24} xs={24} style={{ padding: '0px' }}>
                              <Form.Item name={[field.name, "City"]} rules={[{ required: activeCaseType?.IsEFileAddressRequiredPlaintiff == "Y" }]} label="City">
                                <Input />
                              </Form.Item>
                            </Col>
                            <Col xl={11} lg={11} md={11} sm={24} xs={24} offset={2}>
                              <Form.Item name={[field.name, "State"]} rules={[{ required: activeCaseType?.IsEFileAddressRequiredPlaintiff == "Y" }]} label="State" style={{ width: "100%" }}>
                                <Input maxLength={2} />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row gutter={16}>
                            <Col xl={11} lg={11} md={11} sm={24} xs={24} style={{ padding: '0px' }}>
                              <Form.Item name={[field.name, "Zip"]} rules={[{ required: activeCaseType?.IsEFileAddressRequiredPlaintiff == "Y" }]} label="Zipcode">
                                <Input />
                              </Form.Item>
                            </Col>
                            <Form.Item noStyle shouldUpdate>
                              {() => {
                                const plaintiffBusiness = plaintiffForm.getFieldValue(["Participants", field.name, "IsBusiness"]);
                                return (
                                  <Col xl={11} lg={11} md={11} sm={24} xs={24} offset={2} hidden={plaintiffBusiness}>
                                    <Form.Item name={[field.name, "DateOfBirth"]} label="Date of Birth" >
                                      <DatePicker format={defaultDateFormat} disabledDate={(e) => e > moment()}
                                        onChange={(date) => {
                                          if (date) {
                                            plaintiffForm.setFields([{ name: ["Participants", field.name, "DateOfBirth"], value: date }]);
                                          }
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>
                                )
                              }}
                            </Form.Item>
                          </Row>
                          <Row gutter={16}>
                            <Form.Item name={[field.name, "PhoneNumber"]} rules={[{ required: activeCaseType?.IsEFilePhoneRequiredPlaintiff == "Y" }]} label="Phone Number">
                              <Input />
                            </Form.Item>
                          </Row>
                          <Row gutter={16}>
                            <Form.Item name={[field.name, "Email"]} label="Email" rules={[{ type: "email", message: "The input is not valid E-mail!" }, { required: activeCaseType?.IsEmailRequiredRequiredPlaintiff == "Y" }]}>
                              <Input />
                            </Form.Item>
                          </Row>
                          <Row>
                            <Col style={{ display: "flex", gap: 8 }}>
                              <Button onClick={() => addPlaintiff(add, fields.length)} >Add Additional Plaintiff</Button>
                              <Button onClick={() => deletePlaintiff(remove, fields.length, field.name)} hidden={fields.length == 1}>Delete Plaintiff</Button>
                            </Col>
                          </Row>
                          <Row justify="space-between" align="middle" style={{ marginTop: 24 }} hidden={plaintiffCount == 1}>
                            <Col>
                              <Button onClick={goPrevPlaintiff} hidden={activePlaintiffIndex == 0}>Previous</Button>
                            </Col>
                            <Col>
                              <Button onClick={goNextPlaintiff} hidden={plaintiffCount == 1} disabled={activePlaintiffIndex == plaintiffCount - 1}>Next</Button>
                            </Col>
                          </Row>
                        </BannerCard>
                      </>);
                  }}
                </Form.List>
              </Form>
            </Col>
            <Col xl={11} lg={11} md={11} sm={24} xs={24}>
              <Form form={defendantForm} name="defendantForm" onFinish={submitNewCivilCase} labelAlign="left"
                initialValues={{
                  Participants: [new NewCivilParty()]
                }}>
                <Form.List name="Participants">
                  {(fields, { add, remove }) => {
                    const total = fields.length;
                    const safeIndex = Math.min(activeDefendantIndex, Math.max(0, total - 1));
                    const field = fields[safeIndex];
                    return (
                      <>
                        <div style={{ display: "none" }}>
                          {fields.map((f) => (
                            <React.Fragment key={`validation-${f.key}`}>
                              <Form.Item name={[f.name, "AddressLine1"]} rules={[{ required: activeCaseType?.IsEFileAddressRequiredDefendant == "Y" }]}>
                                <Input />
                              </Form.Item>
                              <Form.Item name={[f.name, "Zip"]} rules={[{ required: activeCaseType?.IsEFileAddressRequiredDefendant == "Y" }]}>
                                <Input />
                              </Form.Item>
                              <Form.Item name={[f.name, "City"]} rules={[{ required: activeCaseType?.IsEFileAddressRequiredDefendant == "Y" }]}>
                                <Input />
                              </Form.Item>
                              <Form.Item name={[f.name, "State"]} rules={[{ required: activeCaseType?.IsEFileAddressRequiredDefendant == "Y" }]}>
                                <Input />
                              </Form.Item>
                              <Form.Item name={[f.name, "Email"]} rules={[{ required: activeCaseType?.IsEmailRequiredRequiredDefendant == "Y" }]}>
                                <Input />
                              </Form.Item>
                              <Form.Item name={[f.name, "PhoneNumber"]} rules={[{ required: activeCaseType?.IsEFilePhoneRequiredDefendant == "Y" }]}>
                                <Input />
                              </Form.Item>
                            </React.Fragment>))}
                        </div>
                        <BannerCard title="Defendant Details">
                          <Row justify="space-between" align="middle" style={{ marginBottom: 12 }}>
                            <Col style={{ fontWeight: 600 }}>
                              Defendant {activeDefendantIndex + 1} of {defendantCount}
                            </Col>
                          </Row>
                          <Form.Item name={[field.name, "IsPlaintiff"]} hidden />
                          <Row>
                            <Form.Item name={[field.name, "IsBusiness"]} label="Business Defendant" initialValue={false}>
                              <Switch onChange={(checked) => handleDefendantBusiness(checked, field.name)} />
                            </Form.Item>
                          </Row>
                          <Form.Item noStyle shouldUpdate>
                            {() => {
                              const defendantBusiness = defendantForm.getFieldValue(["Participants", field.name, "IsBusiness"]);
                              return (
                                <>
                                  <Row gutter={16} hidden={defendantBusiness}>
                                    <Form.Item name={[field.name, "FirstName"]} label="First Name" style={{ width: '100%' }} rules={[{ required: !defendantBusiness }]}>
                                      <Input placeholder="Defendant First Name"
                                      />
                                    </Form.Item>
                                  </Row>
                                  <Row gutter={16}> <Form.Item name={[field.name, "LastName"]} label={defendantBusiness ? "Business Name" : "Last Name"} style={{ width: '100%' }} rules={[{ required: true }]}>
                                    <Input placeholder={defendantBusiness ? "Business Name" : "Last Name"} />
                                  </Form.Item>
                                  </Row>
                                </>
                              );
                            }}
                          </Form.Item>

                          <Row gutter={16}>
                            <Form.Item name={[field.name, "AddressLine1"]} style={{ width: '100%' }} rules={[{ required: activeCaseType?.IsEFileAddressRequiredDefendant == "Y" }]} label="Address Line 1">
                              <Input />
                            </Form.Item>
                          </Row>
                          <Row gutter={16}>
                            <Form.Item name={[field.name, "AddressLine2"]} style={{ width: '100%' }} label="Address Line 2">
                              <Input />
                            </Form.Item>
                          </Row>
                          <Row gutter={16}>
                            <Col xl={11} lg={11} md={11} sm={24} xs={24} style={{ padding: '0px' }}>
                              <Form.Item name={[field.name, "City"]} rules={[{ required: activeCaseType?.IsEFileAddressRequiredDefendant == "Y" }]} label="City">
                                <Input />
                              </Form.Item>
                            </Col>
                            <Col xl={11} lg={11} md={11} sm={24} xs={24} offset={2}>
                              <Form.Item name={[field.name, "State"]} rules={[{ required: activeCaseType?.IsEFileAddressRequiredDefendant == "Y" }]} label="State">
                                <Input maxLength={2} />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row gutter={16}>
                            <Col xl={11} lg={11} md={11} sm={24} xs={24} style={{ padding: '0px' }}>
                              <Form.Item name={[field.name, "Zip"]} rules={[{ required: activeCaseType?.IsEFileAddressRequiredDefendant == "Y" }]} label="Zipcode">
                                <Input />
                              </Form.Item>
                            </Col>
                            <Form.Item noStyle shouldUpdate>
                              {() => {
                                const defendantBusiness = defendantForm.getFieldValue(["Participants", field.name, "IsBusiness"]);
                                return (
                                  <>
                                    <Col xl={11} lg={11} md={11} sm={24} xs={24} offset={2} hidden={defendantBusiness}>
                                      <Form.Item name={[field.name, "DateOfBirth"]} label="Date of Birth">
                                        <DatePicker format={defaultDateFormat} disabledDate={(e) => e > moment()}
                                          onChange={(date) => {
                                            if (date) {
                                              defendantForm.setFields([{ name: ["Participants", field.name, "DateOfBirth"], value: date }]);
                                            }
                                          }}
                                        />

                                      </Form.Item>
                                    </Col>

                                  </>
                                );
                              }}
                            </Form.Item>

                          </Row>
                          <Row gutter={16}>
                            <Form.Item name={[field.name, "PhoneNumber"]} rules={[{ required: activeCaseType?.IsEFilePhoneRequiredDefendant == "Y" }]} label="Phone Number">
                              <Input />
                            </Form.Item>
                          </Row>
                          <Row gutter={16}>
                            <Form.Item name={[field.name, "Email"]} label="Email" rules={[{ type: "email", message: "The input is not valid E-mail!" }, { required: activeCaseType?.IsEmailRequiredRequiredDefendant == "Y" }]}>
                              <Input />
                            </Form.Item>
                          </Row>
                          <Row>
                            <Col style={{ display: "flex", gap: 8 }}>
                              <Button onClick={() => addDefendant(add, fields.length)} >Add Additional Defendant</Button>
                              <Button onClick={() => deleteDefendant(remove, fields.length, field.name)} hidden={fields.length == 1}>Delete Defendant</Button>
                            </Col>
                          </Row>
                          <Row justify="space-between" align="middle" style={{ marginTop: 24 }} hidden={defendantCount == 1}>
                            <Col>
                              <Button onClick={goPrevDefendant} hidden={activeDefendantIndex == 0}>Previous</Button>
                            </Col>
                            <Col>
                              <Button onClick={goNextDefendant} hidden={defendantCount == 1} disabled={activeDefendantIndex == defendantCount - 1}>Next</Button>
                            </Col>
                          </Row>
                        </BannerCard>
                      </>);
                  }}
                </Form.List>
              </Form>
            </Col>
          </Row>
          {/*{(false) ? (*/}
          {/*  //<CleanButton onClick={() => setIsModalVisible(true)} icon="money-bill">Submit Payment</CleanButton>) :*/}
          {/*  (*/}
          <Form.Item
            name="Documents"
            label="Documents"
          >
            <Upload beforeUpload={() => false} accept={configurations?.cvAllowedDocumentExtensions}>
              <CleanButton onClick={() => console.log("file")} icon="upload">Add Additional Documentation</CleanButton>
            </Upload>
          </Form.Item>
          <br />
          <CleanButton onClick={submitNewCivilCase} icon="check" htmlType="submit" loading={submitEFileLoader}>
            Submit
          </CleanButton>
        </Form>

        <Modal width={720} cancelText="Close" visible={isModalVisible} onOk={() => console.log("ok")} closable={false} cancelButtonProps={{ style: { display: 'none' } }} okButtonProps={{ style: { display: 'none' } }}>
          <CivilEFilePayment moneyInCode={activeCaseType?.EFileFeeTemplateFK} feeDue={activeCaseType?.FeeAmount} isFromEFile={true} setIsModalVisible={setIsModalVisible} />
        </Modal>
      </Page.Content>
    </Page>
  );
};

export default NewCivilCase;
